import { DeliveryNotificationsComponent } from './pages/delivery-notifications/delivery-notifications.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, CanActivate } from '@angular/router';

// pages
import { LoginComponent } from './pages/login/login.component';
import { HomeComponent } from './pages/home/home.component';
import { UsersComponent } from './pages/users/users.component';
import { ExchangeComponent } from './pages/exchange/exchange.component';
import { ConfigComponent } from './pages/config/config.component';
import { AuthGuard } from './guards/auth-guard';
import { EMComponent } from './pages/invoices-em/invoices-em.component';
import { CheckInvoicesComponent } from './pages/check-invoices/check-invoices.component';
import { ProcessInvoicesComponent } from './pages/process-invoices/process-invoices.component';
import { SeeComplementComponent } from './pages/see-complement/see-complement.component';
import { UploadComplementComponent } from './pages/upload-complement/upload-complement.component';
import { AccountStatusComponent } from './pages/account-status/account-status.component';
import { ComplementLoadedComponent } from "./pages/complement-loaded/complement-loaded.component";
import { SeeInvoicesComponent } from './pages/see-invoices/see-invoices.component';
import { InvoicesVendorComponent } from './pages/invoices-vendor/invoices-vendor.component';
import { CrudFb60Component } from './pages/crud-fb60/crud-fb60.component';
import { WarehouseComponent } from './pages/warehouse/warehouse.component';
import { ManualsComponent } from './pages/manuals/manuals.component';
import { InvoicesDCComponent } from './pages/invoices-dc/invoices-dc.component';
import { InvoicesAComponent } from './pages/invoices-a/invoices-a.component';
import { InvoicesECComponent } from './pages/invoices-ec/invoices-ec.component';
import { ReportPendingComponent } from './pages/report-pending/report-pending.component';
import { EstatusCargaFacturasComponent } from './pages/status-uploadedInvoices/estatus-cargaFacturas.component';
import { EMMassiveComponent } from './pages/invoices-em-massive/invoicesem-massive.component';
import { InvoicesVendorMassiveComponent } from './pages/invoices-vendor-massive/invoices-vendor-massive/invoices-vendor-massive.component';
import { UploadVouchersComponent } from './pages/my-vouchers/upload-vouchers/upload-vouchers.component';
import { VouchersReportComponent } from './pages/my-vouchers/vouchers-report/vouchers-report.component';
import { CrudRegimenFiscalComponent } from './pages/regimen-fiscal/regimen-fiscal.component';
import { IndicadoresDeImpuestosComponent } from './pages/indicadores-impuestos/indicadores-impuestos.component';
import { InvoicesAduanalaesComponent } from './pages/invoices-aduanales/invoices-aduanales.component';

const routes: Routes = [


  {
    path: 'login',
    component: LoginComponent

  },

  {
    path: 'home',
    component: HomeComponent,
    children: [
      {
        path: 'users',
        component: UsersComponent,
        canActivate: [AuthGuard],
        data: { roles: [1] }
      },
      {
        path: 'config',
        component: ConfigComponent,
        canActivate: [AuthGuard],
        data: { roles: [1] }
      },
      {
        path: 'exchange',
        component: ExchangeComponent,
        canActivate: [AuthGuard],
        data: { roles: [1] }
      },
      {
        path: 'invoices-em',
        component: EMComponent,
        canActivate: [AuthGuard],
        data: { 
          roles: [2, 3],
          permisos: [1]
        }
      },
      {
        path: 'invoices-vendor',
        component: InvoicesVendorComponent,
        canActivate: [AuthGuard],
        data: { 
          roles: [2, 3],
          permisos: [2]
        }
      },
      {
        path: 'invoices-dc',
        component: InvoicesDCComponent,
        canActivate: [AuthGuard],
        data: { 
          roles: [2, 3],
          permisos: [7] 
        }
      },
      {
        path: 'invoices-a',
        component: InvoicesAComponent,
        canActivate: [AuthGuard],
        data: { 
          roles: [2, 3],
          permisos: [6] 
        }
      },
      {
        path: 'invoices-ec',
        component: InvoicesECComponent,
        canActivate: [AuthGuard],
        data: { 
          roles: [2, 3],
          permisos: [8]
        }
      },
      {
        path: 'check-invoices',
        component: CheckInvoicesComponent,
        canActivate: [AuthGuard],
        data: { roles: [5] }
      },
      {
        path: 'report-pending',
        component: ReportPendingComponent,
        canActivate: [AuthGuard],
        data: { 
          roles: [2, 3],
          permisos: [3]
        }
      },
      {
        path: 'complement-loaded',
        component: ComplementLoadedComponent,
        canActivate: [AuthGuard],
        data: { 
          roles: [2, 3],
          permisos: [3]
        }
      },
      {
        path: 'process-invoices',
        component: ProcessInvoicesComponent,
        canActivate: [AuthGuard],
        data: { 
          roles: [2, 3],
          permisos: [3]
        }
      },
      {
        path: 'see-complement',
        component: SeeComplementComponent,
        canActivate: [AuthGuard],
        data: { 
          roles: [2, 3],
          permisos: [5]
        }
      },
      {
        path: 'upload-complement',
        component: UploadComplementComponent,
        canActivate: [AuthGuard],
        data: { 
          roles: [2, 3],
          permisos: [4]
        }
      },
      {
        path: 'account-status',
        component: AccountStatusComponent,
        canActivate: [AuthGuard],
        data: { 
          roles: [2, 3],
          permisos: [3]
        }
      },
      {
        path: 'see-invoices',
        component: SeeInvoicesComponent,
        canActivate: [AuthGuard],
        data: { roles: [5] }
      },
      {
        path: 'crud',
        component: CrudFb60Component,
        canActivate: [AuthGuard],
        data: { roles: [5] }
      },
      {
        path: 'warehouse',
        component: WarehouseComponent,
        canActivate: [AuthGuard],
        data: { roles: [5] }
      },
      {
        path: 'delivery-notifications',
        component: DeliveryNotificationsComponent,
        canActivate: [AuthGuard],
        data: { roles: [5] }
      },
      {
        path: 'status-uploaded-invoices',
        component: EstatusCargaFacturasComponent,
        canActivate: [AuthGuard],
        data: { 
          roles: [2, 3],
          permisos: [3]
        }
      },
      {
        path: 'invoices-massive',
        component: InvoicesVendorMassiveComponent,
        canActivate: [AuthGuard],
        data: { 
          roles: [2, 3],
          permisos: [9]
        }
      },
      {
        path: 'upload-vouchers',
        component: UploadVouchersComponent,
        canActivate: [AuthGuard],
        data: { 
          roles: [2],
          permisos: [10]
        }
      },
      {
        path: 'vouchers-report',
        component: VouchersReportComponent,
        canActivate: [AuthGuard],
        data: { 
          roles: [2, 3],
          permisos: [10]
        }
      },
      {
        path: 'manuals',
        component: ManualsComponent,
        canActivate: [AuthGuard],
        data: { roles: [5] }
      },
      {
        path: 'regimen-fiscal',
        component: CrudRegimenFiscalComponent,
        canActivate: [AuthGuard],
        data: { roles: [1] }
      },
      {
        path: 'indicadores-impuestos',
        component: IndicadoresDeImpuestosComponent,
        canActivate: [AuthGuard],
        data: { roles: [1] }
      },
      {
        path: 'invoices-aduanales',
        component: InvoicesAduanalaesComponent,
        canActivate: [AuthGuard],
        data: { 
          roles: [2, 3],
          permisos: [1]
        }
      }

    ],
    // canActivate: [AuthGuard]
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', component: LoginComponent }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts